const useInfiniteScroll = (observer, hasMore, isLoading, onLastRef) => {
  const handleLastImageRef = async node => {
    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = await new IntersectionObserver(async entries => {
      if (entries[0].isIntersecting && hasMore && !isLoading) {
        await onLastRef();
      }
    });
    if (node) {
      observer.current.observe(node);
    }
  };
  return {
    handleLastImageRef
  };
};

export default useInfiniteScroll;
